import type { ReactElement } from 'react';
import { Text } from 'recharts';
import {
    isEndAlignedTimeseriesTick,
    timeseriesTickOverflowsPlot,
    type TimeseriesXAxisLayout,
} from './dateUtils';

/** Same Recharts label as main; hidden when off the cadence or it would clip. */
export function timeseriesXAxisTickRenderer(
    layout: TimeseriesXAxisLayout,
    tickCount: number,
    svgWidth = 0,
): (props: any) => ReactElement {
    return ({ x, y, payload, index = 0, verticalAnchor }: any) => {
        if (!isEndAlignedTimeseriesTick(index, tickCount, layout.tickStep)) {
            return <g />;
        }
        const value = payload?.value == null ? '' : String(payload.value);
        if (!value) return <g />;
        if (
            typeof x === 'number'
            && timeseriesTickOverflowsPlot(
                x,
                value,
                layout.fontSize,
                layout.angle,
                layout.textAnchor,
                svgWidth,
            )
        ) {
            return <g />;
        }
        return (
            <Text
                x={x}
                y={y}
                angle={layout.angle}
                textAnchor={layout.textAnchor}
                verticalAnchor={verticalAnchor ?? 'start'}
                fill="#4A5568"
                fontSize={layout.fontSize}
            >
                {value}
            </Text>
        );
    };
}
